import { Col, Row } from 'antd';
import { ReactComponent as SignInLandingPage } from '../../../assets/svg/sign-in-landing-page.svg';
import React from 'react';

const FEATURE_IMAGE_STYLE = { maxWidth: 269, borderRadius: 12 };
const LandingPage: React.FC<{}> = () => {
  const content = (
    <>
      <div className="flex-shrink-0" style={{ marginTop: '3em' }} />
      <Row justify="center" style={{ zIndex: 1 }}>
        <Col xs={0} sm={0} md={0} lg={24} xxl={23} className="d-flex flex-column justify-content-center px-5">
          <div className="heading-s mb-4">Forest is all you need living in a community</div>
          <Row>
            <Col span={12} style={{ maxWidth: 269 }} className="mr-4">
              <img
                src="/img/landing/feature-post.png"
                alt="post"
                className="mb-4 shadow-lg"
                style={FEATURE_IMAGE_STYLE}
              />
              <img
                src="/img/landing/feature-request.png"
                alt="request"
                className="mb-4 shadow-lg"
                style={FEATURE_IMAGE_STYLE}
              />
            </Col>
            <Col span={12} style={{ maxWidth: 269 }} className="">
              <img
                src="/img/landing/feature-announcement.png"
                alt="announcement"
                className="mb-4 shadow-lg"
                style={FEATURE_IMAGE_STYLE}
              />
              <img
                src="/img/landing/feature-document.png"
                alt="documents"
                className="mb-4 shadow-lg"
                style={FEATURE_IMAGE_STYLE}
              />
            </Col>
          </Row>
          <div className="ml-1 my-4">
            <a className="text-content-tertiary" href="/#" onClick={(e) => e.preventDefault()}>
              Terms
            </a>
            <span className="mx-2 text-content-tertiary"> | </span>
            <a className="text-content-tertiary" href="/privacy">
              Privacy
            </a>
          </div>
        </Col>
      </Row>
      <div>
        <div className="position-absolute" style={{ bottom: 0, right: 0 }}>
          <SignInLandingPage className="img-fluid" style={{ marginBottom: -5 }} />
        </div>
      </div>
    </>
  );
  return (
    <>
      <div className="d-none d-md-flex flex-column flex-grow-1 justify-content-center overflow-auto bg-background-secondary">
        <div className="d-flex flex-column justify-content-between vh-100">{content}</div>
      </div>
      <div className="d-flex d-md-none flex-column flex-grow-1 justify-content-between bg-background-secondary px-4">
        {content}
      </div>
    </>
  );
};

export default LandingPage;
